module.exports = __webpack_public_path__ + "static/img/england.b9e3cb84.jpg";